import React from 'react';
import { Button, Modal } from 'antd';

import addDocSvg from 'assets/images/addDocSvg.svg';

interface Props {
  visible: boolean;
  setVisible: Function;
  title: string;
  description?: string;
  submit: { buttonLabel: string, onSubmit: Function, color?: 'white' | 'red' };
  cancel?: { buttonLabel: string, color?: 'white' | 'red', onClick?: Function };
  icon?: any;
  className?: string;
}

const ModalBasic = ({
  visible,
  setVisible,
  title,
  description,
  submit,
  cancel,
  icon,
  className,
}: Props) => {

  const handleCancel = () => setVisible(false);

  const renderIcon = () => {
    if (!icon) {
      return <img className="coin" alt="coin" src={addDocSvg} />;
    }
    if (typeof icon === 'string') {
      return <img className="coin" alt="coin" src={icon} />;
    }
    return <div className="coin">{icon}</div>;
  };

  return (
    <Modal
      open={visible}
      onCancel={handleCancel}
      className={`modal-basic ${className || ''}`}
    >
      <div className="modal-end-submit__content">
        {renderIcon()}
        <h2 className="h2">{title}</h2>
        <h4 className="h4 h4-w4 mt-10" style={{ color: className === 'modal-basic--small-screen' ? '#8C7A6E' : '#404859' }}>
          {description}
        </h4>
        <div className="buttons">
          <Button 
            className={`button ${!submit.color && 'button-modal-ok'} button--${submit.color} icon-share`} 
            onClick={() => submit.onSubmit()}
          >
            {submit.buttonLabel}
          </Button>
          {cancel && 
            <Button 
              className={`button ${!submit.color && 'button-modal-ok'} button--${cancel.color}`} 
              onClick={(e) => cancel?.onClick? cancel?.onClick(e): setVisible(false)}
            >
              {cancel.buttonLabel}
            </Button>
          }
        </div>
      </div>
    </Modal>
  );
};
export default ModalBasic;
